import { getBackgroundImage } from "../../helpers";
import { buildBasketballLiveMobileProps } from "../../builders/buildBasketballLiveMobileProps";
export const buildBasketballLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildBasketballLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildBasketballLiveDesktopProps.js.map